var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssemble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0891 14L10.0391 12.95L11.2181 11.7895H8.14176V10.3158H11.2181L10.0576 9.13684L11.0891 8.10526L14.0365 11.0526L11.0891 14ZM0.036499 13.2632V8.8421H1.51018V11.7895H4.45755V13.2632H0.036499ZM0.036499 4.42105V0H4.45755V1.47368H1.51018V4.42105H0.036499ZM11.826 4.42105V1.47368H8.8786V0H13.2997V4.42105H11.826Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssemble);
export default __webpack_public_path__ + "static/media/assemble.a2ac2b301f3268c66dd3d8544d15fdd0.svg";
export { ForwardRef as ReactComponent };